import SignIn from "@pages/public/SignIn/signin.component";
import TokenUI from "@pages/public/Token";
import { createBrowserRouter, Navigate } from "react-router-dom";

/**
 * @description Rotas não autenticadas do projeto
 */
export const Public = createBrowserRouter([
	{
		path: "/",
		element: <SignIn />,
	},
	{
		path: "/signin/:token?",
		element: <TokenUI />,
	},
	{
		path: "/recorder/:id",
		element: <SignIn />,
	},
	{
		path: "/admin/manual-fix",
		element: <Navigate to="/" replace />,
	},
]);
